export enum TokenValidationMessageTemplateType {
  proposal = 'proposal',
  userValidation = 'userValidation'
}

export class TokenValidationModel {}
